import React, { useRef, useState, useEffect } from "react";


// import Aboutus from '../Pages/Aboutus.js';
// import Productpage from '../Pages/Productpage.js';
// import Reviews from '../Pages/Reviews.js';
// import AllCategory from '../Pages/AllCategory.js';
import '../Style.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import $ from "jquery";
import Marquee from "react-fast-marquee";

import 'swiper/css/effect-coverflow';


// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import 'swiper/css/free-mode';
// Import Swiper styles
import "swiper/css";
import { Autoplay, EffectCoverflow } from 'swiper/modules';
// import 'swiper/css/effect-flip';

// banner_images
import img_1 from '../Assets/Images/banner-images/1.jpg';
import img_2 from '../Assets/Images/banner-images/2.jpg';
import img_3 from '../Assets/Images/banner-images/3.jpg';
import img_4 from '../Assets/Images/banner-images/4.jpg';
import img_5 from '../Assets/Images/banner-images/5.jpg';
import img_6 from '../Assets/Images/banner-images/6.jpg';
import img_7 from '../Assets/Images/banner-images/7.jpg';
import img_8 from '../Assets/Images/banner-images/8.jpg';
import img_9 from '../Assets/Images/banner-images/9.jpg';
import img_10 from '../Assets/Images/banner-images/10.jpg';
import img_11 from '../Assets/Images/banner-images/11.jpg';
import img_12 from '../Assets/Images/banner-images/12.jpg';
import img_13 from '../Assets/Images/banner-images/13.jpg';
import img_14 from '../Assets/Images/banner-images/14.jpg';
import img_15 from '../Assets/Images/banner-images/15.jpg';
import img_16 from '../Assets/Images/banner-images/16.jpg';
import img_17 from '../Assets/Images/banner-images/17.jpg';
import img_18 from '../Assets/Images/banner-images/18.jpg';
import img_19 from '../Assets/Images/banner-images/19.jpg';
import img_20 from '../Assets/Images/banner-images/20.jpg';
import img_21 from '../Assets/Images/banner-images/21.jpg';
import img_22 from '../Assets/Images/banner-images/22.jpg';




import minitableimg_1 from '../Assets/Images/Economic Scales/Mini Table Top Scale/Milton_Chottu_Scale.png'
import minitableimg_2 from '../Assets/Images/Economic Scales/Mini Table Top Scale/Economic_Chottu_Scale.png'
import minitableimg_3 from '../Assets/Images/Economic Scales/Mini Table Top Scale/BTB-5.png'
import minitableimg_6 from '../Assets/Images/Economic Scales/Mini Table Top Scale/MTB-6.png'
import minitableimg_8 from '../Assets/Images/Economic Scales/Mini Table Top Scale/Mini_Pole.png'
import BTB_10 from '../Assets/Images/Economic Scales/Table Top Scale/BTB-10.png'
import BTB_10_pole from '../Assets/Images/Economic Scales/Table Top Scale/BTB-10_Pole.png'
import BTB_14 from '../Assets/Images/Economic Scales/Table Top Scale/BTB-14.png'
import MTB_14 from '../Assets/Images/Economic Scales/Table Top Scale/MTB-14.png'
import MS_Platform_500x500mm from '../Assets/Images/Economic Scales/Platform Scale/MS_Platform_500x500mm.png'
import SS_Platform_500x500mm from '../Assets/Images/Economic Scales/Platform Scale/SS_Platform_500x500mm.png'
import IMG_7213 from '../Assets/Images/Economic Scales/Portable Scale/IMG_7213.png'
import IMG_7558 from '../Assets/Images/Economic Scales/Portable Scale/IMG_7558.png'
import four_load_platform from '../Assets/Images/Economic Scales/Heavy Duty Platform Scale/4_Loadcell_Platform.png'
import heavy_MS_platform from '../Assets/Images/Economic Scales/Heavy Duty Platform Scale/Heavyduty_Scale.png'
import mpf35_20 from '../Assets/Images/Economic Scales/Portable Scale/mpf35_20.png';
import mpf35_50 from '../Assets/Images/Economic Scales/Portable Scale/mpf35_50.png';
import bpf35_250 from '../Assets/Images/Economic Scales/Portable Scale/SS_250.png';
import bpf35_400 from '../Assets/Images/Economic Scales/Portable Scale/SS_400.png';

import banner1 from '../Assets/Images/banner-img-1.jpg';
import banner2 from '../Assets/Images/banner-img-2.jpg';

import { VscWorkspaceTrusted } from "react-icons/vsc";
import aboutimg from '../Assets/Images/about-img.png';
import { BiRightTopArrowCircle } from "react-icons/bi";
import { FaArrowRight } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import logo from '../Assets/Images/logo-short.png';
function Mainbanner() {



  return (
    <div>
      <section id="banner-swiper" className="py-5">
        <div className="container pt-5  ">
          <div className="row row-cols-lg-1 row-cols-1 min-lg-vh-100 g-4 ">

            <div className="col ">

              <Swiper
                // effect={'flip'}  
                breakpoints={{
                  // when window width is >= 320px
                  120: {
                    slidesPerView: 2,
                    spaceBetween: 10
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 3,
                    spaceBetween: 30
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 40
                  }
                }}

                effect={'coverflow'}
                slidesPerView={'auto'}
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                }}
                spaceBetween={30}
                centeredSlides={true}
                grabCursor={true}
                loop={true}
                speed={1000}
                // freeMode={true}

                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}

                modules={[Autoplay, EffectCoverflow]}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_1} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_2} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_3} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_4} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_5} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_6} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_7} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_8} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_9} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_10} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_11} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_12} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_13} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_14} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_15} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_16} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_17} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_18} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_19} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_20} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_21} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="text-center swiper-slide ">
                    <img src={img_22} />
                  </div>
                </SwiperSlide>

              </Swiper>
            </div>

            {/* <div className="col text-center">
              <p class="banner-heading-section-css">The Reliable Weighing Partner</p>
              <p class="para-small-font-css">Tired of inaccurate measurements? Let's elevate your weighing experience. Our state-of-the-art scales offer unmatched accuracy and reliability.
              </p>
              <a href="/#product_section" >
                <button className="btn more-btn-css-styling ">Explore Now <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                </button>
              </a>
            </div> */}

          </div>
        </div>
      </section >

      {/* ==========================section-2=========================================== */}
      {/* 
       */}


      {/* 
      <section className=" full-bg-css py-5">
        <div className="container">
          <div className="row row-cols-lg-3 row-cols-1 justify-content-center text-center g-4">
            <div className="col ">
              <div className=" ">
                <VscWorkspaceTrusted className="about-icon-css mb-3 " />
                <p className="about-card-heading-css">
                  Parallel Display</p>
                <p className="about-card-para-css">& Poll Display
                </p>
              </div>
            </div>
            <div className="col ">
              <div className=" ">
                <VscWorkspaceTrusted className="about-icon-css mb-3 " />
                <p className="about-card-heading-css">
                  Piece / Counting Facility
                </p>
                <p className="about-card-para-css">Memory Accumulation
                </p>
              </div>
            </div>
            <div className="col ">
              <div className=" ">
                <VscWorkspaceTrusted className="about-icon-css mb-3 " />
                <p className="about-card-heading-css">
                  RS - 232
                </p>
                <p className="about-card-para-css">Interface with computer and printer.
                </p>
              </div>
            </div>
            <div className="col ">
              <div className=" ">
                <VscWorkspaceTrusted className="about-icon-css mb-3 " />
                <p className="about-card-heading-css">
                  Backrail</p>
                <p className="about-card-para-css">For heavy duty platforrm.
                </p>
              </div>
            </div>
            <div className="col ">
              <div className=" ">
                <VscWorkspaceTrusted className="about-icon-css mb-3 " />
                <p className="about-card-heading-css">
                  In Built Battery Backup</p>
                <p className="about-card-para-css">Overload indication and software calibration.
                </p>
              </div>
            </div>
            <div className="col ">
              <div className=" ">
                <VscWorkspaceTrusted className="about-icon-css mb-3 " />
                <p className="about-card-heading-css">
                  High Precision Load Cell</p>
                <p className="about-card-para-css">Change your Website's Primary Scheme instantly by simply adding the dark class.
                </p>
              </div>
            </div>


          </div>
        </div>
      </section> */}

      {/* ==========================products=========================================== */}

      <section id="product_section">
        <div className="container pt-3 ">
          <div className="row row-cols-lg-2 row-cols-1 justify-content-between align-items-center ">
            <div className="col">
              <div class="d-flex flex-row align-items-center">
                <div class="headline-dot "></div>
                <p class="ps-2 text-size-caption mb-0">Products</p>
              </div>
              <div className="border-bottom-css " ></div>

              <div class="mt-3">
                <p class="section-top-heading-css">Discover our exclusive collection</p>

              </div>

            </div>
            <div className="col text-end d-none d-lg-block">
              {/* <button className="btn more-btn-css-styling ">View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
              </button> */}
            </div>
          </div>
          {/* ==========================Category-1============================== */}
          <div className="">
            <div className="row mt-lg-4 row-cols-lg-2 row-cols-2 g-3 justify-content-between align-items-center ">
              <div className="col">
                <div class="">
                  <p class="swiper-card-heading-css">Mini table top scale</p>
                </div>
              </div>
              <div className="col text-end ">
                <button className="btn ">
                  <a href="/Minitabletop" className="more-btn-css-styling">
                    View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                  </a>
                </button>
              </div>
            </div>
            <div className="row row-cols-lg-4 row-cols-2 g-2 g-lg-4 mt-3 justify-content-center  ">

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image text-center" src={minitableimg_3} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">BTB-5</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 10/20 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 1/2 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={minitableimg_8} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample">Minipole</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 10/20 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start">Accuracy : 1/2 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>

              <div className="col d-none d-lg-block ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={minitableimg_6} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">MTB-6</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 10/20 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 1/2 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={minitableimg_1} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Milton Chottu</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 10,20 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 1,2 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>


            </div>
          </div>
          {/* ==========================Category-2============================== */}
          <div className="">
            <div className="row mt-4 row-cols-lg-2 row-cols-2 g-3 justify-content-between align-items-center ">
              <div className="col">
                <div class="">
                  <p class="swiper-card-heading-css">Table top scale</p>
                </div>
              </div>
              <div className="col text-end ">
                <button className="btn">
                  <a href="/Tabletopscale" className="more-btn-css-styling">
                    View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                  </a>
                </button>
              </div>
            </div>
            <div className="row row-cols-lg-4 row-cols-2 g-2 g-lg-4 mt-3 justify-content-center  ">

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={BTB_10} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">BTB-10</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 20/30 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 2/5 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={BTB_10_pole} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample">BTB-10 Pole</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 20/30 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start">Accuracy : 2/5 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>

              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={BTB_14} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">BTB-14</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 20/30 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 2/5 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={MTB_14} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">MTB-14</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 20/30 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 2/5 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>


            </div>
          </div>
          {/* ==========================Category-3============================== */}
          <div className="d-lg-block d-block">
            <div className="row mt-4 row-cols-lg-2 row-cols-2 g-3 justify-content-between align-items-center ">
              <div className="col">
                <div class="">
                  <p class="swiper-card-heading-css">Platform Scale</p>
                </div>
              </div>
              <div className="col text-end ">
                <button className="btn ">
                  <a href="/Platformscale" className="more-btn-css-styling">
                    View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                  </a>
                </button>
              </div>
            </div>
            <div className="row row-cols-lg-4 row-cols-2 g-2 g-lg-4 mt-3 justify-content-center  ">

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={MS_Platform_500x500mm} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Mild Steel ( MS ) Platform</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 100 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 10 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={SS_Platform_500x500mm} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Stainless Steel ( SS ) Platform</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 150 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 10 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={SS_Platform_500x500mm} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample">Stainless Steel ( SS ) Platform</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 100 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start">Accuracy : 10 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={SS_Platform_500x500mm} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample">Mild Steel ( MS ) Platform</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 150 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start">Accuracy : 10 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>




            </div>
          </div>

          {/* ==========================Category-4============================== */}
          <div className="d-lg-block d-block">
            <div className="row mt-4 row-cols-lg-2 row-cols-2 g-3 justify-content-between align-items-center ">
              <div className="col">
                <div class="">
                  <p class="swiper-card-heading-css">Portable scale</p>
                </div>
              </div>
              <div className="col text-end ">
                <button className="btn ">
                  <a href="/Portablescale" className="more-btn-css-styling">
                    View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                  </a>
                </button>
              </div>
            </div>
            <div className="row row-cols-lg-4 row-cols-2 g-2 g-lg-4 mt-3 justify-content-center  ">

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={mpf35_20} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Portable Scale<br /> ( MS )</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 20 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 2 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={mpf35_50} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Portable Scale ( MS )</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 50 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 5 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={bpf35_250} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample">Portable Scale <br /> ( SS )</p>
                    <p className="about-card-para-css px-2 pb-1 text-lg-center text-start">Platter Size ( mm ) : 250 x 250</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 d-none d-lg-block"><br /></p>

                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={bpf35_400} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample">Portable Scale ( SS )</p>
                    {/* <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 150 kg</p> */}

                    <p className="about-card-para-css px-2 text-lg-center text-start">Platter Size ( mm ) : 400 x 400</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 "><br /></p>

                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>




            </div>
          </div>

          {/* ==========================Category-5============================== */}
          <div className="d-lg-block d-block">
            <div className="row mt-4 row-cols-lg-2 row-cols-2 g-3 justify-content-between align-items-center ">
              <div className="col">
                <div class="">
                  <p class="swiper-card-heading-css">Heavy Duty Platform Scale</p>
                </div>
              </div>
              <div className="col text-end ">
                <button className="btn ">
                  <a href="/Heavydutyplatformscale" className="more-btn-css-styling">
                    View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                  </a>
                </button>
              </div>
            </div>
            <div className="row row-cols-lg-4 row-cols-2 g-2 g-lg-4 mt-3 justify-content-center  ">

              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={four_load_platform} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Four load cell </p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 2000 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 200 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={four_load_platform} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2  product-heading-sample">Four load cell </p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 1000 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start ">Accuracy : 100 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>
                  </div>
                </div>
              </div>
              <div className="col ">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={heavy_MS_platform} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample"> Mild Steel ( MS ) Platform</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 300 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start">Accuracy : 50 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <div className="border-sample-css ">
                  <div className="card home-product-card-css h-100">
                    <div className="text-center image-stretch-css">
                      <img className="product-swiper-image" src={heavy_MS_platform} />
                    </div>
                    <p className="text-lg-center text-start height-css px-2 mb-lg-3 mb-2 product-heading-sample"> Mild Steel ( MS ) Platform</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start mb-1 ">Capacity : 500 kg</p>
                    <p className="about-card-para-css px-2 text-lg-center text-start">Accuracy : 50 g</p>
                    <a href="https://wa.me/919443030062" target="_blank" className="mx-2" >

                      <button className="btn CTA-button-css-2 ">
                        Get Price <span><IoIosSend className="ms-lg-2 button-icon-css" /></span>

                      </button> </a>

                  </div>
                </div>
              </div>




            </div>
          </div>


          <div className="text-center mt-4">
            <a href="/AllCategory" >
              <button className="btn more-btn-css-styling ">View All Categories <BiRightTopArrowCircle className="ms-2 button-icon-css" />
              </button>
            </a>
          </div>
        </div>
      </section >

      {/* ==========================about=========================================== */}
      < section id="aboutsection" className="" >
        <div className="container ">

          <div className="row row-cols-lg-2 row-cols-1  g-4 justify-content-center min-vh-lg-100 py-5 align-items-center ">

            <div className="col">
              <div class="d-flex flex-row align-items-center">
                <div class="headline-dot "></div>
                <p class="ps-2 text-size-caption mb-0">About us</p>
              </div>
              <div className="border-bottom-css " ></div>

              <div class="mt-3">
                <p class="section-top-heading-css">Economic Scales: Weighing In on Precision</p>
                <div class="">
                  <p class="para-small-font-css">Economic Scales is a leading manufacturer of high-quality weighing machines, offering a wide range of products for industrial, commercial, and domestic use. Since our inception in 1978, we have been committed to innovation, precision, and customer satisfaction.
                  </p>
                  <p class="para-small-font-css">Providing accurate and reliable weighing solutions that enhance the efficiency and productivity of our customers' operations. Global leader in the weighing industry, known for quality, and customer-centric approach.
                  </p>
                  <p class="para-small-font-css"><span className="about-card-heading-css">Industrial Weighing Machines:</span> Heavy-duty scales, platform scales, crane scales.<br />
                    <span className="about-card-heading-css">Commercial Weighing Machines:</span>
                    Retail scales, price computing, piece counting scales.
                    <br />
                    Comprehensive after-sale maintenance and Support.

                  </p>
                </div>
                <a href="/AllCategory" >
                  <button className="btn more-btn-css-styling ">Learn More <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                  </button>
                </a>
              </div>

            </div>
            <div className="col text-lg-end d-none d-lg-block text-center">
              <img className="about-img-css" src={aboutimg} />

            </div>
          </div>

        </div>
      </section >
      {/* ==========================Experience=========================================== */}

      {/* <section className="pb-5">
        <div className="container">
          <div className="row row-cols-lg-4 row-cols-1 justify-content-center g-4 pt-4">
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  6K</p>
                <p className="about-card-para-css">Number Of Customers</p>
              </div>
            </div>
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  100%</p>
                <p className="about-card-para-css">Top Class Service</p>
              </div>
            </div>
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  46</p>
                <p className="about-card-para-css">Number of Years</p>
              </div>
            </div>
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  11</p>
                <p className="about-card-para-css">11 Product Category</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="pb-5">
        <div className="container">
          <div className="row row-cols-lg-4 row-cols-1 justify-content-center g-4 pt-4">
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  Precision You Can Trust</p>
                <p className="about-card-para-css">Our advanced micro-controller technology ensures accurate measurements, every time.</p>
              </div>
            </div>
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  Quality That Lasts</p>
                <p className="about-card-para-css">Built to withstand the test of time, our machines are designed for long-lasting performance.</p>
              </div>
            </div>
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  Customer-Centric Approach</p>
                <p className="about-card-para-css">We’re committed to providing exceptional customer service and support.</p>
              </div>
            </div>
            <div className="col">
              <div className="about-small-card-css card h-100 p-4">
                <VscWorkspaceTrusted className="about-icon-css mb-3" />
                <p className="about-card-heading-css">
                  ISO 9001:2015 Certified</p>
                <p className="about-card-para-css">Our commitment to quality is backed by international standards.</p>
              </div>
            </div>
          </div>
        </div>
      </section>



    </div >

  );
}

export default Mainbanner;
